import { combineReducers } from "redux";
import contactPerson from "./contactPerson";

export default combineReducers({
    contactPerson
});
